import _classCallCheck from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/classCallCheck";
import _createClass from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/createClass";
import axios from "axios";
import qs from "qs";
import LocalStorage from 'quasar/src/plugins/LocalStorage.js';import SessionStorage from 'quasar/src/plugins/SessionStorage.js';;

var ProjectsOccupancies =
/*#__PURE__*/
function () {
  function ProjectsOccupancies() {
    _classCallCheck(this, ProjectsOccupancies);
  }

  _createClass(ProjectsOccupancies, null, [{
    key: "CreateProjectOccupancy",
    value: function CreateProjectOccupancy(projectOccupancy) {
      return axios.post("api/projectsoccupancies/CreateProjectOccupancy", projectOccupancy);
    }
  }, {
    key: "GetOccupancyHistory",
    value: function GetOccupancyHistory(projectId, numMonths) {
      return axios.get("api/projectsoccupancies/GetProjectOccupancyHistory", {
        params: {
          projectId: projectId,
          numMonths: numMonths
        }
      });
    }
  }, {
    key: "CreateProjectOccupancySpecialNeedsDetail",
    value: function CreateProjectOccupancySpecialNeedsDetail(projectOccupancySNDetail) {
      return axios.post("api/projectsoccupancies/CreateProjectOccupancySpecialNeedsDetail", projectOccupancySNDetail);
    }
  }, {
    key: "CreateProjectOccupancyRoomType",
    value: function CreateProjectOccupancyRoomType(projectOccupancyId, projectRoomTypeId, vacantCount) {
      return axios.post("api/projectsoccupancies/CreateProjectOccupancyRoomType", {
        ProjectOccupancyId: projectOccupancyId,
        ProjectRoomTypeId: projectRoomTypeId,
        VacantCount: vacantCount
      });
    }
  }, {
    key: "UpdateProjectOccupancyRoomType",
    value: function UpdateProjectOccupancyRoomType(projectOccupancyId, projectRoomTypeId, vacantCount) {
      return axios.patch("api/projectsoccupancies/UpdateProjectOccupancyRoomType", {
        ProjectOccupancyId: projectOccupancyId,
        ProjectRoomTypeId: projectRoomTypeId,
        VacantCount: vacantCount
      });
    }
  }, {
    key: "UpdateProjectOccupancy",
    value: function UpdateProjectOccupancy(projectOccupancy) {
      return axios.patch("api/projectsoccupancies/UpdateProjectOccupancy", projectOccupancy);
    }
  }, {
    key: "UpdaterojectOccupancySpecialNeedsDetail",
    value: function UpdaterojectOccupancySpecialNeedsDetail(projectOccupancyDetail) {
      return axios.patch("api/projectsoccupancies/UpdaterojectOccupancySpecialNeedsDetail", projectOccupancyDetail);
    }
  }, {
    key: "GetProjectRoomTypes",
    value: function GetProjectRoomTypes(projectId) {
      return axios.get("api/projectsoccupancies/GetRoomTypes", {
        params: {
          projectId: projectId
        }
      });
    }
  }, {
    key: "GetProjectRoomTypesUnitCount",
    value: function GetProjectRoomTypesUnitCount(projectRoomTypeId) {
      return axios.get("api/projectsoccupancies/GetProjectRoomTypesUnitCount", {
        params: {
          projectRoomTypeId: projectRoomTypeId
        }
      });
    }
  }, {
    key: "GetAverageProjectOccupancies",
    value: function GetAverageProjectOccupancies(projectId) {
      return axios.get("api/projectsoccupancies/GetAverageProjectOccupancies", {
        params: {
          projectId: projectId
        }
      });
    }
  }, {
    key: "GetProjectOccupancies",
    value: function GetProjectOccupancies(projectId, fetchCount, startRow, sortBy, descending, filter) {
      return axios.get("api/projectsoccupancies/GetProjectOccupancies", {
        params: {
          startRow: startRow,
          fetchCount: fetchCount,
          sortBy: sortBy,
          descending: descending,
          projectId: projectId,
          filter: filter
        }
      });
    }
  }, {
    key: "getRequestCount",
    value: function getRequestCount(projectId, fetchCount, startRow, sortBy, descending, filter) {
      return axios.get("api/projectsoccupancies/getRequestCount", {
        params: {
          startRow: startRow,
          fetchCount: fetchCount,
          sortBy: sortBy,
          descending: descending,
          projectId: projectId,
          filter: filter
        }
      });
    }
  }, {
    key: "getProjectOccupancyRoomTypes",
    value: function getProjectOccupancyRoomTypes(projectId, projectOccupancyId) {
      return axios.get("api/projectsoccupancies/getProjectOccupancyRoomTypes", {
        params: {
          projectId: projectId,
          projectOccupancyId: projectOccupancyId
        }
      });
    }
  }, {
    key: "GetAllProjectOccupancies",
    value: function GetAllProjectOccupancies() {
      return axios.get("api/projectsoccupancies/GetAllProjectOccupancies");
    }
  }, {
    key: "GetProjectOccupancySNVacantDetails",
    value: function GetProjectOccupancySNVacantDetails(projectOccupancyId) {
      return axios.get("api/projectsoccupancies/GetProjectOccupancySNVacantDetails", {
        params: {
          projectOccupancyId: projectOccupancyId
        }
      });
    }
  }, {
    key: "GetProjectOccupancyById",
    value: function GetProjectOccupancyById(projectOccupancyId) {
      return axios.get("api/projectsoccupancies/GetProjectOccupancyById", {
        params: {
          projectOccupancyId: projectOccupancyId
        }
      });
    }
  }, {
    key: "GetPreviousProjectOccupancy",
    value: function GetPreviousProjectOccupancy(projectOccupancyId, projectId) {
      return axios.get("api/projectsoccupancies/GetPreviousProjectOccupancy", {
        params: {
          projectOccupancyId: projectOccupancyId,
          projectId: projectId
        }
      });
    }
  }, {
    key: "GetAllProjectOccupanciesCount",
    value: function GetAllProjectOccupanciesCount(projectId) {
      return axios.get("api/projectsoccupancies/GetAllProjectOccupanciesCount", {
        params: {
          projectId: projectId
        }
      });
    }
  }, {
    key: "GetVawaList",
    value: function GetVawaList() {
      return axios.get("api/projectsoccupancies/GetVawaList");
    }
  }]);

  return ProjectsOccupancies;
}();

export { ProjectsOccupancies as default };